module.exports = __webpack_public_path__ + "front/img/13.e162485b.png";